//RUTAS RUTAS WEB
//-gam
export const urlGetWebRoutes = "/api/navbar/routes";
export const urlCreateWebRoutes = "/api/navbar/routes";
export const urlEditWebRoutes = "/api/navbar/routes";
//--borrar ruta
export const urlDeleteWebRoute = "/api/navbar/routes/delete"